import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-afd674f2")

_pushScopeId("data-v-afd674f2")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex flex-wrap" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = { for: "email" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_AdminPanelHeader = _resolveComponent("AdminPanelHeader")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_BaseTooltipWrapper = _resolveComponent("BaseTooltipWrapper")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Input = _resolveComponent("Input")!
  const _component_BaseButtonWithSpinner = _resolveComponent("BaseButtonWithSpinner")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_AdminPanelHeader, {
      title: _ctx.$t('adminPanel.users.title')
    }, {
      default: _withId(() => [
        _createVNode(_component_Button, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showInviteModal = true))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.inviteUser')), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_DataTable, {
      value: _ctx.users,
      responsiveLayout: "scroll"
    }, {
      default: _withId(() => [
        _createVNode(_component_Column, {
          field: "email",
          header: _ctx.$t('adminPanel.users.headers.email')
        }, null, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "pending",
          header: _ctx.$t('adminPanel.users.headers.status')
        }, {
          body: _withId((slotProps) => [
            _createTextVNode(_toDisplayString(slotProps.data.pending ? _ctx.$t('adminPanel.users.pending') : _ctx.$t('adminPanel.users.active')), 1)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "roles",
          header: _ctx.$t('adminPanel.users.headers.roles')
        }, {
          body: _withId((slotProps) => [
            (slotProps.data.roles)
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  _createVNode(_component_Chip, {
                    class: ["mr1 role", slotProps.data.roles.admin && 'role--active'],
                    onClick: ($event: any) => (_ctx.updateRole(slotProps.data.id, 'admin', slotProps.data.roles))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.admin')), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"]),
                  _createVNode(_component_Chip, {
                    class: ["role", slotProps.data.roles.gameCreator && 'role--active'],
                    onClick: ($event: any) => (_ctx.updateRole(slotProps.data.id, 'gameCreator', slotProps.data.roles))
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.gameCreator')), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["header"]),
        _createVNode(_component_Column, {
          field: "email",
          header: _ctx.$t('adminPanel.users.headers.actions')
        }, {
          body: _withId((slotProps) => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_BaseTooltipWrapper, {
                tooltip: _ctx.$t('adminPanel.users.copyInviteLinkTooltip')
              }, {
                default: _withId(() => [
                  (slotProps.data.inviteUrl)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "action-button",
                        onClick: ($event: any) => (_ctx.copy(slotProps.data.inviteUrl))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.copyInviteLink')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["tooltip"]),
              _createVNode(_component_Button, {
                class: "action-button p-button-outlined",
                onClick: ($event: any) => (_ctx.removeUser(slotProps.data.email))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.removeUser')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["header"])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_Dialog, {
      class: "users__modal",
      visible: _ctx.showInviteModal,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_ctx.showInviteModal = $event))
    }, {
      header: _withId(() => [
        _createVNode("h3", null, _toDisplayString(_ctx.$t('adminPanel.users.inviteUser')), 1)
      ]),
      footer: _withId(() => [
        _createVNode(_component_BaseButtonWithSpinner, {
          onClick: _ctx.handleInvite,
          loading: _ctx.inviteLoading
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('adminPanel.users.invite')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      default: _withId(() => [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_Input, {
            id: "email",
            type: "text",
            autofocus: "",
            modelValue: _ctx.inviteEmail,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.inviteEmail = $event)),
            onKeyup: _withKeys(_ctx.handleInvite, ["enter"])
          }, null, 8, ["modelValue", "onKeyup"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('adminPanel.users.headers.email')), 1)
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
})